import { useCallback, useEffect, useMemo } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';

import PopupNg from '@/ui/PopupNg';
import { denormalizeSportEventId } from '@/nikeone/domain/sportevent';
import { browserInfo } from '../web-notification-browser';
import { loadMatchNotificationTypes } from '@/notifications/handlers';
import { matchSubscriptionTypes$, matchNotificationTypes$ } from '@/notifications/subs';
import useNotificationHandlerWrapper from '@/notifications/components/useNotificationHandlerWrapper';

export default function useMatchNotification(sportEventId, handler) {
    const { subscribe } = useReframe();
    const eventId = useMemo(() => String(denormalizeSportEventId(sportEventId)), [sportEventId]);
    const info = browserInfo();
    const browserSupported = info.browserSupported;
    useEffect(() => {
        if (browserSupported) {
            dispatch(loadMatchNotificationTypes(eventId));
        }
    }, [browserSupported, eventId]);

    const memoHandler = useCallback(() => {
        if (typeof handler === 'function') {
            handler();
        } else {
            PopupNg.dispatcher.open('notifications/matches', { eventId }, 20);
        }
    }, [handler, eventId]);

    const { withRegisteredNotif } = useNotificationHandlerWrapper(info);
    if (!browserSupported) {
        return [false, 0, null, null, eventId];
    }

    const subscribedTypes = subscribe(matchSubscriptionTypes$(eventId)) || [];
    const notificationTypes = subscribe(matchNotificationTypes$(eventId));
    return [browserSupported, subscribedTypes.length, notificationTypes, withRegisteredNotif(memoHandler), eventId];
}
